import { Head, Link, usePage } from "@inertiajs/react";
import styled, { keyframes } from "styled-components";
import { GlobalStyle } from "../../constants/global-style";
import { brand_orange_deep, brand_success, dark } from "../../constants/styles";
import AuthLayout from "../../auth/AuthLayout";
import ChannelPicker from "../../auth/ChannelPicker";

// "Check your inbox" waiting page. Reached from Signup.jsx via
// router.visit(location_url) after a successful registration. The user must
// pick a channel (Email active today; WhatsApp "Segera hadir").

const drawCheck = keyframes`
  0%   { stroke-dashoffset: 44; }
  100% { stroke-dashoffset: 0; }
`;

const drawCircle = keyframes`
  0%   { stroke-dashoffset: 170; }
  100% { stroke-dashoffset: 0; }
`;

const Mark = styled.svg`
  width: 72px;
  height: 72px;
  display: block;
  margin-bottom: 8px;

  .circle {
    fill: none;
    stroke: ${brand_success};
    stroke-width: 3;
    stroke-dasharray: 170;
    stroke-dashoffset: 170;
    animation: ${drawCircle} 680ms ease-out forwards;
  }

  .check {
    fill: none;
    stroke: ${brand_success};
    stroke-width: 3.5;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 44;
    stroke-dashoffset: 44;
    animation: ${drawCheck} 420ms ease-out 500ms forwards;
  }
`;

const Heading = styled.h1`
  font-size: 32px;
  font-weight: 800;
  letter-spacing: -0.01em;
  margin: 0 0 10px;
  color: #111827;

  [data-theme="dark"] & {
    color: ${dark.text_primary};
  }
`;

const Body = styled.p`
  margin: 0 0 20px;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.7;

  & strong {
    color: ${brand_orange_deep};
    font-weight: 700;
  }

  [data-theme="dark"] & {
    color: ${dark.text_secondary};
  }
`;

const SecondaryLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 20px;
  font-size: 13px;
  color: #6b7280;

  & a {
    color: ${brand_orange_deep};
    font-weight: 600;
    text-decoration: none;
  }

  & a:hover,
  & a:focus-visible {
    text-decoration: underline;
  }

  [data-theme="dark"] & {
    color: ${dark.text_secondary};
  }
`;

export default function CheckInbox() {
  const {
    email,
    resend_email_path: resendEmailPath,
    wa_enabled: waEnabled,
  } = usePage().props;

  return (
    <>
      <Head>
        <title>Cek inbox Anda — Taxsam Learning Center</title>
      </Head>
      <GlobalStyle />
      <AuthLayout imageSide="left">
        <Mark viewBox="0 0 64 64" aria-hidden="true">
          <circle className="circle" cx="32" cy="32" r="28" />
          <polyline className="check" points="20,33 29,42 45,24" />
        </Mark>
        <Heading>Hampir selesai!</Heading>
        <Body>
          Kami siap mengirim tautan konfirmasi ke <strong>{email}</strong>.
          Pilih salah satu metode di bawah untuk melanjutkan. Klik tautan yang
          kami kirim untuk mengaktifkan akun Anda.
        </Body>
        <ChannelPicker
          email={email}
          resendEmailPath={resendEmailPath}
          waEnabled={!!waEnabled}
        />
        <SecondaryLinks>
          <div>
            Salah memasukkan email? <Link href="/signup">Daftar ulang</Link>
          </div>
          <div>
            Sudah konfirmasi? <Link href="/login">Masuk sekarang</Link>
          </div>
          <div>
            <Link href="/">Kembali ke beranda</Link>
          </div>
        </SecondaryLinks>
      </AuthLayout>
    </>
  );
}
